import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from 'bootstrap-vue';

import '../node_modules/animate.css';
import '../node_modules/fullpage-vue/src/fullpage.css';
import VueFullpage from '../node_modules/fullpage-vue';

import 'animate.css/animate.css';

Vue.use(BootstrapVue);
Vue.use(VueFullpage);

Vue.config.productionTip = false;

new Vue({
  data() {
    return {
      hasHeader: true,
      title: '示漫談台灣選舉文化',
    };
  },
  router,
  render: h => h(App),
}).$mount('#app');
